import axios from 'axios';
import { catDataUrl } from 'utils/constantsHelper';

export const getCarsByPlateNumber = (carPlate) => {
  return axios.get(catDataUrl, { params: { input: carPlate } });
};



// WEBPACK FOOTER //
// ./src/utils/getCarsByPlateNumber.js